module.exports = [
    {
        id: 1,
        name: '4525 W Benoit Trl, Blacksburg, VA 24060',
        location:'Virginia',
		year: '2003',
        status: 'For Sale',
        price: '$159,900',
        match: '24',
        eco:'30',
        description:
            '5 Bed | 4 Bath | 4,120 Square feet',
        message:
            'Single-family home. Heat pump for heating and cooling. Has 3.45 Acres of land.',
        image: require('./images/Exterior/01.png')
    },
    {
        id: 2,
        name: '1315 Henry Ln, APT D Blackburg, VA 24060',
        location:'Virginia',
		year: 'n/a',
        status: 'For Rent',
        price: '$1,600/mo',
        match: '87',
        eco:'93',
        description:
            '2 Bed | 2 Bath | 900 Square feet',
        message: "Apartment. Allow pets. In unit laundry.",
        image: require('./images/Exterior/02.png')
    },
    {
        id: 3,
        name: '2027 Daylily St, Blacksburg, VA 24060',
        location:'Virginia',
		year: '2023',
        status: 'Under Contract',
        price: '$390,750',
        match: '97',
        eco:'94',
        description:
            '3 Bed | 3 Bath | 2,046 Square feet',
        message:
            'Townhouse. Natural gas heating. 1 attached garage.',
        image: require('./images/Exterior/03.png')
    },
    {
        id: 4,
        name: '3530 Belaire Dr, Blacksburg, VA 24060',
        location:'Virginia',
		year: '1974',
        status: 'For Sale',
        price: '$259,900',
        match: '88',
        eco:'73',
        description:
            '3 Bed | 2 Bath | 1,452 Square feet',
        message: "Single-family home. Heat pump for heating and cooling. 1 Acre of land.",
        image: require('./images/Exterior/04.png')
    },
    {
        id: 5,
        name: '1402 University City Blvd, #J, Blacksburg, VA 24060',
        location:'Virginia',
		year: '1987',
        status: 'For Rent',
        price: '$1,300/mo',
        match: '99',
        eco:'91',
        description:
            '1 Bed | 1 Bath | 432 Square feet',
        message: "Apartment. Electric, Heat pump for heating. Central air cooling.",
        image: require('./images/Exterior/05.png')
    },
	{
        id: 6,
        name: '916 Kentwood Dr, Blacksburg, VA 24060',
        location:'Virginia',
		year: '2019',
        status: 'Under Contract',
        price: '$650,000',
        match: '57',
        eco:'56',
        description:
            '4 Bed | 4 Bath | 2,246 Square feet',
        message: "Single-family home. Bike able neighborhood. Electric, heat pump for cooling.",
        image: require('./images/Exterior/06.png')
    },
	{
        id: 7,
        name: '2028 Coneflower Ln, Blacksburg, VA 24060',
        location:'Virginia',
		year: '2023',
        status: 'New Construction',
        price: '$454,900',
        match: '79',
        eco:'66',
        description:
            '3 Bed | 3 Bath | 2,118 Square feet',
        message: "Townhome. Not car dependent. 2 car garage.",
        image: require('./images/Exterior/07.png')
    },
	{
        id: 8,
        name: '922 Kabrich St, Blacksburg, VA 24060',
        location:'Virginia',
		year: '2008',
        status: 'For Sale',
        price: '$720,000',
        match: '91',
        eco:'23',
        description:
            '6 Bed | 6 Bath | 3,306 Square feet',
        message: "Townhome. Electric for water heater. Heat pump for cooling and heating.",
        image: require('./images/Exterior/08.png')
    },
	{
        id: 9,
        name: '1701 Liberty Ln, Unit 89, Blacksburg, VA 24060',
        location:'Virginia',
		year: 'n/a',
        status: 'For Rent',
        price: '$1,800/mo',
        match: '69',
        eco:'40',
        description:
            '2-4 Bed | 2-4 Bath | 859-1,484 Square feet',
        message: "Apartment. Media center. Smoke free. Trash removal.",
        image: require('./images/Exterior/09.png')
    },
	{
        id: 10,
        name: '1711 Whipple Dr, Blacksburg, VA 24060',
        location:'Virginia',
		year: '2019',
        status: 'Under Comtract',
        price: '$525/mo',
        match: '79',
        eco:'69',
        description:
            '4 Bed | 2 Bath | 1,058 Square feet',
        message: "Apartment. Furnished unit. Separate leases",
        image: require('./images/Exterior/10.png')
    },
];